import './offers_requests_view.css';

import React, { useState , useEffect } from 'react';
import { useHistory } from "react-router-dom";

import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import SearchIcon from '@mui/icons-material/Search';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Fab from '@mui/material/Fab';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/Download';
import Tooltip from '@mui/material/Tooltip';
import GroupIcon from '@mui/icons-material/Group';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Pagination from "react-js-pagination";

import Loading_animation_view from '../../loading_animation_view/loading_animation_view'
import DemandeAppel_Dialog from './offer_request_View/offer_request_Dialog'
import Set_commission from './set_commissions_View/set_commissions_view'

import { get_submitted_offers, download_offer_files, update_offer_call_docs } from '../../../services/purchase_service';
import { get_auditors_for_service } from '../../../services/auditor_service';
import { get_categories_forAll_services } from '../../../services/for_allServices';




const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: 16,
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  input: {
    display: 'none',
  }
}));


const headCells = [
  { id: 'object', numeric: true, disablePadding: false, label: 'Object' },
  { id: 'categorie', numeric: true, disablePadding: false, label: "Famille d'achat" },
  { id: 'offer_date', numeric: true, disablePadding: false, label: 'Date offre' },
  { id: 'limit_date', numeric: true, disablePadding: false, label: 'Date limite' },
  { id: 'dateOuverture', numeric: true, disablePadding: false, label: 'Date d\'ouverture des plis' },
  { id: 'estimation', numeric: true, disablePadding: false, label: 'Estimation' },
  //{ id: 'commission', numeric: true, disablePadding: false, label: 'Commission' },
  { id: 'pv', numeric: true, disablePadding: false, label: 'PV' },
  { id: 'visualiser', numeric: true, disablePadding: false, label: 'Visualiser' },
];


function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>

        {
          headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align='left'
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};


function CompareFinalDate_current(finalDate){
  let day = new Date(finalDate);
  let current_date = new Date();
  /*if(day.getTime() > current_date.getTime()) return false;
  else return true;*/
  return true;
}



function Offers_requests_view() {

  let user=JSON.parse(localStorage.getItem('user-info'))
  let history = useHistory();
  const [url_updated , setUrl_updated] = useState(null);

  const classes = useStyles();
  const [categories, setCategories] = React.useState([]);

  const [demandeList, setdemandeList] = useState(null);
  const [offerClicked,SetofferClicked]=useState(null);

  const [waiting, setWaiting] = useState(false);
  const [open, setOpen] = useState(false);

  const [auditors, setAuditors] = useState(null);
  const [openCommission, setOpenCommission] = useState(false);

  const [filter_categorie,setFilter_categorie]=useState("all");
  const [search_value,setsearch_value]=useState("");
  const [search_filter,setsearch_filter]=useState('all');

  const [currentPage,setCurrentPage]=useState(1);
  const [dataPerPage,setdataPerPage] =useState(6);
  const [data_count,setdata_count]=useState(0);

  const handleClose = () => {
    setOpen(false);
    SetofferClicked(null);
  };

  const handleCloseCommission = () => {
    setOpenCommission(false);
    SetofferClicked(null);
    setAuditors(null);
  };

  useEffect(()=>{
    setdemandeList(null);
    setdata_count(0);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    var tmp_searchFilter ="all";
    var tmp_searchValue = null;
    var tmp_filterCategorie = "all";
    async function load_data(){
      if(urlParams.get('filtre') && urlParams.get('valeur')){
        tmp_searchFilter = urlParams.get('filtre');
        tmp_searchValue = urlParams.get('valeur');
      }if(urlParams.get('categorie')){
        tmp_filterCategorie = urlParams.get('categorie');
      }
      await setsearch_filter(tmp_searchFilter);
        await setsearch_value(tmp_searchValue);
        await setFilter_categorie(tmp_filterCategorie);

      await get_categories_forAll_services().then((response)=> {
        setCategories(response.data);
      }).catch((error)=>{
        //console.log(error.response);
      });
    
      let page = (urlParams.get('page')?urlParams.get('page'):1);
        await setCurrentPage(page)

      await get_submitted_offers(user.id,tmp_filterCategorie,tmp_searchFilter,tmp_searchValue,page)
        .then((response)=> {
          //console.log(response.data);
          setdata_count(response.data.total);
          setdemandeList(response.data.data);
        }).catch((error) => {
          //console.log(error.response);
        })      
    }
    
    load_data();

  },[url_updated,history.location]);
  

  function getCategorieById(id){
    var categorie="";
    categories.map((catg)=>{
      if(catg.id_category == id) categorie = catg.name;
    })
    return categorie;
  }

  function load_commission_infos(offer_id){
    setOpenCommission(true);
    SetofferClicked(offer_id);
    get_auditors_for_service().then((response) => {
      //console.log(response.data);
      setAuditors(response.data);
    }).catch((error) => {
        //console.log(error.response);
    });
  }

  

  function downloadProposalDocsForSupplier(choice,offer_id){
    setWaiting(true);
    const formData = new FormData();
    formData.append('offer_id',offer_id);
    formData.append('choice',choice);
    download_offer_files(formData).then((response) => {
      setWaiting(false);
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        let file_extension = '';
        const disposition = response.headers['content-disposition'];
        if (disposition && disposition.includes('filename')) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
                file_extension = matches[1].replace(/['"]/g, '').split(".")[1];
            }
        }
        fileLink.setAttribute('download', offer_id+"_"+choice+"."+file_extension);
        document.body.appendChild(fileLink);
        fileLink.click();
      }).catch((error)=>{
        //console.log(error.response);
      });
  }

  function upload_pv_docs(event,choice, offer_id){
    setWaiting(true);
    let formData = new FormData();
    formData.append(choice,event.target.files[0]);
    formData.append("offer_id",offer_id);
    update_offer_call_docs(formData).then((response)=>{
      setWaiting(false);
      //console.log(response.data);
      setdemandeList(demandeList=>({
        ...demandeList,
        [offer_id] : [response.data]
      }));
      //console.log(demandeList);
    }).catch((error)=>{
      setWaiting(false);
      //console.log(error);
    });
  }

  function search(){
    if(filter_categorie!=="all") history.push("/serviceAchat/soumissions?categorie="+filter_categorie+"&filtre="+search_filter+"&valeur="+search_value);
    else history.push("/serviceAchat/soumissions?filtre="+search_filter+"&valeur="+search_value);
    setUrl_updated(search_value);
  }


  function set__categorie(value){
    setFilter_categorie(value);
    if(value!=="all") history.push("/serviceAchat/soumissions?categorie="+value);
    else history.push("/serviceAchat/soumissions?categorie=all");
    setUrl_updated(value);
  }

  function set__filter(value){
    if(value==="all"){
      setsearch_filter(value);
      if(filter_categorie!=="all") history.push("/serviceAchat/soumissions?categorie="+filter_categorie+"&filtre="+value);
      else history.push("/serviceAchat/soumissions?filtre="+value);
      setUrl_updated(value);
    }else setsearch_filter(value);
  }


  async function change_page(page){
    await setCurrentPage(page);
    let path = history.location.pathname;
    let params = history.location.search;
    let search_params = params.split('&');
    let tmp_params = path;
    if(!params) history.push(path+"?page="+page);
    else{
      for(let i in search_params){
        if(search_params[i].includes("page=")){
          if(i==0) tmp_params=tmp_params+"?page="+page;
          else tmp_params=tmp_params+"&page="+page;
        }else{
          if(i==0) tmp_params=tmp_params+search_params[i];
          else tmp_params=tmp_params+"&"+search_params[i];
        }
      }
      if(!tmp_params.includes("page=")) tmp_params=tmp_params+"&page="+page;
      history.push(tmp_params);
    }
    await setUrl_updated(page);
  }

  return (
    <>
      {   
        demandeList==null
        ?<Loading_animation_view />
        : <div className="offresAppel_SubmitView" >
          <div className='three_forms_header_container' >
             <div className='page_title'>Soumissions</div>
              <div className='search_filter_container'>
                <FormControl variant='standard' className="header_form" >
                      <InputLabel id="demo-simple-select-helper-label">Famille d'achat</InputLabel>
                      <Select required value={filter_categorie} 
                            onChange={e => {set__categorie(e.target.value) }} >
                            
                            <MenuItem value={"all"}>Toutes les familles d'achat</MenuItem>
                            {
                            categories.map((categorie,id)=>(
                                <MenuItem value={categorie.id_category} key={id} >{categorie.name}</MenuItem>
                            ))
                            }
                            
                      </Select>
                  </FormControl>

                  <FormControl variant='standard' className="header_form">
                    <InputLabel id="demo-simple-select-helper-label">Filtre</InputLabel>
                      <Select value={search_filter}  onChange={(e)=>{set__filter(e.target.value)}}>
                        <MenuItem value="all">Aucun</MenuItem>
                        <MenuItem value='Object'>Objet d'appel</MenuItem>
                        <MenuItem value='Direction'>Direction</MenuItem>
                      </Select>
                    </FormControl>

                      <Grid container spacing={1} alignItems="flex-start" className={search_filter==="all"?"search_bar disabled_button":"search_bar" } >
                        <Grid item>
                          <SearchIcon onClick={search} className={search_value===""?"my_icon disabled_button":"my_icon" } style={{cursor:"pointer"}}  />
                        </Grid>
                        <Grid>
                          <TextField variant='standard' label="Chercher" value={search_value} onChange={(e)=>{setsearch_value(e.target.value)}}/>
                        </Grid>
                      </Grid>
              </div>
        </div>
            <TableContainer>
              <Table className="submittions_table" aria-labelledby="tableTitle"  aria-label="enhanced table" >
                <TableHead>
                  <TableRow>
                      {
                          headCells.map((column) => (
                              <TableCell key={column.id} align="left">{column.label}</TableCell>
                          ))
                      }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                   Object.keys(demandeList).length!==0
                    ?Object.keys(demandeList).map((offer_id, index) => (
                          <TableRow tabIndex={-1} key={index}>
    
                            <TableCell align="left" component="th" scope="row">
                              {demandeList[offer_id][0].object}
                            </TableCell>
                            <TableCell align="left">{getCategorieById(demandeList[offer_id][0].purchase_family)}</TableCell>
                            <TableCell align="left">{(new Date(demandeList[offer_id][0].offer_date)).toLocaleString()}</TableCell>
                            <TableCell align="left">{(new Date(demandeList[offer_id][0].limit_date)).toLocaleString()}</TableCell>
                            <TableCell align="left">{(new Date(demandeList[offer_id][0].openOffer_date)).toLocaleString()}</TableCell>
                            <TableCell align="center"><b>{demandeList[offer_id][0].estimation+" DH"}</b></TableCell>
                            {/* <TableCell align="center">
                              {
                                CompareFinalDate_current(demandeList[offer_id][0].openOffer_date) != false
                                ?<Tooltip disableFocusListener disableTouchListener title="Date d'ouverture est dépassée !">
                                  <span>
                                    <Fab className="disabled_button" size="small" color="secondary" style={{backgroundColor:'rgb(41,189,141)',color:"white"}} disabled>
                                      <GroupIcon className="my_icon" />
                                    </Fab>
                                  </span>
                                  
                                </Tooltip>
                                :<Fab onClick={()=>{load_commission_infos(demandeList[offer_id][0])}} size="small" color="secondary" style={{backgroundColor:'rgb(41,189,141)'}}>
                                    <GroupIcon className="my_icon" />
                                  </Fab>
                              }
                            </TableCell> */}
                            <TableCell align="center">
                                <div className='documentsContainer'>
                                  <div style={{display:'flex',marginBottom:'10px'}}>
                                    <div className='documentsDownload'>
                                      {
                                      CompareFinalDate_current(demandeList[offer_id][0].openOffer_date) == false
                                      ?<Tooltip htmlFor={"pvO"+demandeList[offer_id][0].id_submission} title="Date d'ouverture pas encore atteinte !">
                                        <label htmlFor={"pvO"+demandeList[offer_id][0].id_submission}> 
                                           <Fab size="small" color="default" component='span' className={CompareFinalDate_current(demandeList[offer_id][0].openOffer_date) == false  ? "disabled_button" : ""}><CloudUploadIcon className="my_icon"  /></Fab>
                                            { 
                                              CompareFinalDate_current(demandeList[offer_id][0].openOffer_date) == false ? <></>
                                              :<input accept="application/*" className={classes.input} name={"pvO"+demandeList[offer_id][0].id_submission} id={"pvO"+demandeList[offer_id][0].id_submission} multiple type="file" onChange={(e)=>upload_pv_docs(e,"open_pv",offer_id)}  />
                                            }
                                        </label>
                                        </Tooltip>
                                        :<label htmlFor={"pvO"+demandeList[offer_id][0].id_submission}> 
                                            <Fab size="small" color="default" component='span' className={CompareFinalDate_current(demandeList[offer_id][0].openOffer_date) == false  ? "disabled_button" : ""}><CloudUploadIcon className="my_icon"  /></Fab>

                                            { 
                                              CompareFinalDate_current(demandeList[offer_id][0].openOffer_date) == false ? <></>
                                              :<input accept="application/*" className={classes.input} name={"pvO"+demandeList[offer_id][0].id_submission} id={"pvO"+demandeList[offer_id][0].id_submission} multiple type="file" onChange={(e)=>upload_pv_docs(e,"open_pv",offer_id)}  />
                                            }
                                        </label>
                                       }
                                          <Fab size="small" className={demandeList[offer_id][0].open_pv == null  ? "disabled_button" : ""} onClick={()=>downloadProposalDocsForSupplier("open_pv",demandeList[offer_id][0].offer_id)} color="default"><DownloadIcon className="my_icon" /></Fab>
                                          <span className='documentsTitle'>PV d'ouverture</span>
                                      </div>
                                   </div>
                                   <div style={{display:'flex',marginBottom:'10px'}}>
                                     <div className='documentsDownload'>
                                     {
                                      CompareFinalDate_current(demandeList[offer_id][0].openOffer_date) == false
                                      ?<Tooltip htmlFor={"pvR"+demandeList[offer_id][0].id_submission} title="Date d'ouverture pas encore atteinte !">
                                          <label htmlFor={"pvR"+demandeList[offer_id][0].id_submission}> 
                                            <Fab size="small" component='span' color="default" className={CompareFinalDate_current(demandeList[offer_id][0].openOffer_date) == false  ? "disabled_button" : ""}><CloudUploadIcon className="my_icon"  /></Fab>
                                            { 
                                            CompareFinalDate_current(demandeList[offer_id][0].openOffer_date) == false? <></>
                                            :<input accept="application/*" className={classes.input} name={"pvR"+demandeList[offer_id][0].id_submission} id={"pvR"+demandeList[offer_id][0].id_submission} multiple type="file" onChange={(e)=>upload_pv_docs(e,"result_pv",offer_id)}  />
                                            }
                                          </label>
                                       </Tooltip>
                                       :<label htmlFor={"pvR"+demandeList[offer_id][0].id_submission}>
                                          <Fab size="small" component='span' color="default" className={CompareFinalDate_current(demandeList[offer_id][0].openOffer_date) == false  ? "disabled_button" : ""}><CloudUploadIcon className="my_icon"  /></Fab>
                                          { 
                                          CompareFinalDate_current(demandeList[offer_id][0].openOffer_date) == false? <></>
                                          :<input accept="application/*" className={classes.input} name={"pvR"+demandeList[offer_id][0].id_submission} id={"pvR"+demandeList[offer_id][0].id_submission} multiple type="file" onChange={(e)=>upload_pv_docs(e,"result_pv",offer_id)}  />
                                          }
                                        </label>
                                      }
                                          <Fab size="small" color="default" className={demandeList[offer_id][0].result_pv == null  ? "disabled_button" : ""} onClick={()=>downloadProposalDocsForSupplier("result_pv",demandeList[offer_id][0].offer_id)} ><DownloadIcon className="my_icon"  /></Fab>
                                          <span className='documentsTitle'>PV resultat</span>
                                     </div>
                                    </div>
                                </div>
                            </TableCell>
                            <TableCell align="center">
                             {
                              CompareFinalDate_current(demandeList[offer_id][0].openOffer_date) == false
                              ?<Tooltip disableFocusListener disableTouchListener title="Date d'ouverture pas encore atteinte !">
                                <span>
                                  <VisibilityIcon  className="my_icon editIcon"  />
                                </span>
                                
                              </Tooltip>
                              : <VisibilityIcon  className="my_icon editIcon" onClick={()=>{setOpen(true);SetofferClicked(demandeList[offer_id][0]);}}/>
                             }
                            </TableCell>
                          </TableRow>
                        ))
                      :<div style={{margin:"10px", textAlign:"center",alignContent:"center"}}>Aucune soumission trouvée</div>
                    }
                </TableBody>
              </Table>
            </TableContainer>
             {
                demandeList.length!==0
                  ?<div className="pagination_container">
                      <Pagination
                          activePage={Number(currentPage)}
                          itemsCountPerPage={dataPerPage}
                          totalItemsCount={Number(data_count)}
                          pageRangeDisplayed={4}
                          onChange={change_page.bind(this)}
                      />
                  </div>
                  :<></>
              }
          {
            offerClicked!=null && open==true
            ?<DemandeAppel_Dialog open={open} onClose={handleClose} handleClose={handleClose} setOpen={setOpen} offerClicked={offerClicked} />
            :<></>
          }
    
          {
            auditors!=null && openCommission==true
            ?<Set_commission openCommission={openCommission} handleCloseCommission={handleCloseCommission} auditors={auditors} offre={offerClicked} profilInfo={user}/>
            :<></>
          }
    
    
    
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
      }
    </>
    
   
  );
}
export default Offers_requests_view
